import React, { Component } from 'react';
import Uuid from '../../../../../support/Uuid';

import InformacionAduaneraForm from './InformacionAduaneraForm';
import InformacionAduaneraList from './InformacionAduaneraList';

class InformacionAduaneraManager extends Component {
  state = {
    editing: undefined
  };

  handleOnAdd = (data) => {
    const { InformacionAduanera = [] } = this.props.data;

    const newData = [].concat(InformacionAduanera, [{
      id: Uuid.v4(),
      ...data
    }]);

    this.setState({
      editing: undefined
    });

    this.props.onChange({
      InformacionAduanera: newData
    });
  }

  handleOnEdit = (item) => {
    this.handleOnDelete(item);

    setTimeout(() => {
      this.setState({
        editing: item
      });
    }, 1);
  }

  handleOnDelete = (item) => {
    const { InformacionAduanera = [] } = this.props.data;

    const newData = InformacionAduanera.filter((value) => item.id !== value.id);

    this.props.onChange({
      InformacionAduanera: newData
    });
  }

  render() {
    const { data } = this.props;
    const { editing } = this.state;

    return (
      <fieldset>
        <legend className="text-muted">Información Aduanera</legend>

        <InformacionAduaneraForm
          onAdd={ this.handleOnAdd }
          data={ editing }
        />

        <div className="py-2"></div>

        <InformacionAduaneraList
          data={ data.InformacionAduanera || [] }
          onEdit={ this.handleOnEdit }
          onDelete={ this.handleOnDelete }
        />
      </fieldset>
    )
  }
}

export default InformacionAduaneraManager;